import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import StatusOptionsMulti from '../../components/psc/lib/StatusOptionsMulti'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'

const StdDocuments = () => {
    const table = useRef(null)
    const urlGetData = '/v0/std_documents'
    const localStorageOrderKey = 'tblStdDocumentsOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'template.filename' },
        { data: 'cadm_object.name' },
    ]

    const tableHead = (
        <tr>
            <th>Type</th>
            <th>Template</th>
            <th>Configured Item</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/std_documents/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/cadm/templates/${row.template.id}`),
        2: (data, type, row) => linkSlot(data, type, row, `/cadm/std_documents/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Portfolio Document Types</h2>
                            
                            <div className="pre-table-buttons">
                                <Link to="/cadm/std_documents/new" className="btn btn-mr btn-primary" type="button">New Portfolio Document Type</Link>
                                <Link to="/cadm/templates">Manage Templates</Link>
                            </div>
                            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Portfolio document types</strong> are selected by the <strong>user</strong> when adding a new <strong>document</strong>, <strong>record</strong> or <strong> customer document</strong> to an <strong>opportunity, project or product</strong>. <br/>
                                These are used to auto-generate <strong>references</strong>, and in <strong>reports</strong>. They also allow the use of <strong>templates</strong> and <strong>SMART templates</strong>.<br/>
                                Portfolio document types are related to <strong>type-codes</strong> using <strong>type-code maps</strong>, and assigned to opportunities, projects, or products through <strong>configuration schemes</strong>. <br/>
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="2"
                                    fetchUrl="/v0/cadm_objects"
                                    localStorageKey="stddocuments-cadm-objects"
                                    placeholder="Select Configured Item..."
                                />
                            </div>

                            <GncDataTable
                            tableRef={table}
                            dataUrl={urlGetData}
                            defaultOrder={defaultOrder}
                            localStorageOrderKey={localStorageOrderKey}
                            columns={columns}
                            tableSlots={tableSlots}
                            tableHead={tableHead}
                            tableFoot={tableHead}
                        />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default StdDocuments
